export enum InvoiceStatus {
  Draft = 'draft',
  Unpaid = 'unpaid',
  Paid = 'paid',
  Overdue = 'overdue',
  Revoked = 'revoked',
  Rejected = 'rejected',
  PartialPaid = 'partial_paid',
  Canceled = 'canceled',
  Verifying = 'verifying',
}
